import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CurrencyContext } from "../features/context/CurrencyContext";
import { base_url } from "../utils/axiosConfig";
import { FaGlobe, FaMobileAlt, FaDatabase, FaCloud } from "react-icons/fa";

const hasRepeatedDigits = (price) => {
  if (!price) return true;
  return /(\d)\1{4,}/.test(String(price));
};

const Home = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [promotional, setPromotional] = useState([]);
  const [vendorProduct, setVendorProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  const testimonialSliderRef = useRef(null);
  const { convertPrice, getCurrencySymbol } = useContext(CurrencyContext);
  const courseDetail = [
    {
      id: "1",
      course: "Digital Emergency Health Kit",
      imageSrc: "/popular/dehk.jpeg",
      price: "300",
      category: "dek",
    },
    {
      id: "15",
      course: "Digital & Physical Emergency Health Kit",
      imageSrc: "/popular/dmehk.png",
      profession: "Learn React Native with Node.js",
      price: "300",
      category: "dmek",
    },
    {
      id: "4",
      course: "Diagnosis",
      imageSrc: "/popular/diagnosis.jpeg",
      profession: "Learn TensorFlow with SQL",
      price: "1500",
      category: "diagnosis",
    },
    {
      id: "14",
      course: "Quick Health Checkup",
      imageSrc: "/popular/qhc.jpeg",
      profession: "Learn Bokeh with Python",
      price: "300",
      category: "qhc",
    },
    {
      id: "3",
      course: "Express Medical Test",
      imageSrc: "/popular/xmt.jpeg",
      profession: "Scikit with Python Development",
      price: "1499",
      category: "emt",
    },
    {
      id: "5",
      course: "Body Recharge Station",
      imageSrc: "/popular/brs.png",
      profession: "Platform-as-a-Service",
      price: "1800",
      category: "brs",
    },
  ];
  const [selectedButton, setSelectedButton] = useState("dek");
  const mobileDevelopment = courseDetail.filter(
    (name) => name.category === "dmek",
  );
  const webDevelopment = courseDetail.filter((name) => name.category === "dek");
  const dataScience = courseDetail.filter(
    (name) => name.category === "diagnosis",
  );
  const cloudComputing = courseDetail.filter((name) => name.category === "qhc");
  const expressMedical = courseDetail.filter((name) => name.category === "emt");
  const bodyRecharge = courseDetail.filter((name) => name.category === "brs");

  let selectedNames = [];
  if (selectedButton === "dmek") {
    selectedNames = mobileDevelopment;
  } else if (selectedButton === "dek") {
    selectedNames = webDevelopment;
  } else if (selectedButton === "diagnosis") {
    selectedNames = dataScience;
  } else if (selectedButton === "qhc") {
    selectedNames = cloudComputing;
  } else if (selectedButton === "emt") {
    selectedNames = expressMedical;
  } else if (selectedButton === "brs") {
    selectedNames = bodyRecharge;
  }

  const nameElements = selectedNames.map((name, index) => (
    <div id="Courses" key={index} className="shadow-lg rounded-xl group flex">
      {/* <div className="py-5 lg:py-0 flex flex-col"> */}
      <a href={`/services/${name.id}`} className="cursor-pointer">
        <div className="overflow-hidden rounded-lg bg-gray-100">
          <img
            src={name.imageSrc}
            alt={name.course}
            width={700}
            height={700}
            className="h-full w-full object-cover object-center"
          />
        </div>
        <div className="p-4 flex flex-col justify-between gap-5 flex-1">
          {/* <div className="flex flex-col gap-3">
            <div className="flex items-center justify-between">
              <p className="w-[60%] font-normal text-gray-900 break-words">
                {name.course}
              </p>
            </div>
          </div> */}
          {/* <div className="flex justify-between border-solid border-2 rounded-md p-2">
            <p>12 Classes</p>
            <div className="flex flex-row space-x-4">
              <div className="flex">
                <Image
                  src={withBasePath("/images/courses/account.svg")}
                  width={18}
                  height={20}
                  alt="circle"
                />
                <p className="text-lightgrey ml-1">120</p>
              </div>
              <div className="flex">
                <Image
                  src={withBasePath("/images/courses/Star.svg")}
                  width={18}
                  height={20}
                  alt="star"
                />
                <p className="ml-1">4.5</p>
              </div>
            </div>
          </div> */}
        </div>
      </a>
      {/* </div> */}
    </div>
  ));

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
    ],
  };

  const banners = [
    { url: "/banner/banner21.jpeg" },
    { url: "/banner/banner22.jpeg" },
    { url: "/banner/banner23.jpeg" },
    { url: "/banner/dehk.jpeg" },
    { url: "/banner/dmek.png" },
    { url: "/banner/diagnosis1.png" },
    { url: "/banner/brs1.png" },
    { url: "/banner/brs2.png" },
    { url: "/banner/brs3.png" },
    { url: "/banner/brs4.png" },
  ];

  const companies = [
    {
      imgSrc: "/company/1a.png",
    },
    {
      imgSrc: "/company/1b.png",
    },
    {
      imgSrc: "/company/1c.png",
    },
    {
      imgSrc: "/company/1d.png",
    },
    {
      imgSrc: "/company/2.png",
    },
    {
      imgSrc: "/company/3.png",
    },
    {
      imgSrc: "/company/4.png",
    },
    {
      imgSrc: "/company/5.png",
    },
    {
      imgSrc: "/company/6.png",
    },
    {
      imgSrc: "/company/7.png",
    },
    {
      imgSrc: "/company/8.png",
    },
    {
      imgSrc: "/company/9.png",
    },
    {
      imgSrc: "/company/10.png",
    },
    {
      imgSrc: "/company/11.jpeg",
    },
    {
      imgSrc: "/company/12.jpeg",
    },
    {
      imgSrc: "/company/13.jpeg",
    },
  ];

  useEffect(() => {
    let start = 0;
    const end = 500;

    const interval = setInterval(() => {
      start++;
      setCount(start);
      if (start === end) clearInterval(interval);
    }, 10);

    return () => clearInterval(interval);
  }, []);

  const isValidProduct = (product) => {
    const price =
      product?.price?.amount ?? product?.variations?.[0]?.price?.amount;

    return price && !hasRepeatedDigits(price);
  };

  const hasProducts = (category) => {
    const check = (items = []) => items.some(isValidProduct);

    if (check(category?.products)) return true;

    return category?.subCategories?.some(
      (sub) =>
        check(sub?.products) ||
        sub?.subSubCategories?.some(
          (ss) =>
            check(ss?.products) ||
            ss?.subSubSubCategories?.some((sss) => check(sss?.products)),
        ),
    );
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        const [catRes, testRes, venRes] = await Promise.all([
          fetch(
            `${base_url}product/getCategory?page=1&limit=100&sortingColumn=createdAt&sortingOrder=asc`,
          ),
          fetch(`${base_url}product/getTestimonialVideo`),
          fetch(`${base_url}v1/vendor/getVendorProductForWebsite`),
        ]);

        if (!catRes.ok || !testRes.ok || !venRes.ok) {
          throw new Error("Failed to fetch data");
        }

        const catData = await catRes.json();
        const testData = await testRes.json();
        const venData = await venRes.json();

        const allProducts =
          catData?.data?.flatMap((category) => {
            // Skip inactive categories
            if (!category?.isActive) return [];

            const catId = category?._id;

            return (
              category?.subCategories
                ?.filter((sub) => sub?.isActive) // Skip inactive subcategories
                ?.flatMap((sub) => {
                  const subId = sub?._id;

                  // Products directly in this sub-category
                  const directProducts = (sub?.products || [])
                    .filter((product) => product?.isActive) // Skip inactive products
                    .map((product) => ({
                      ...product,
                      categoryId: catId,
                      subCategoryId: subId,
                      subSubCategoryId: null,
                    }));

                  // Products from sub-sub-categories
                  const subSubProducts = (sub?.subSubCategories || [])
                    .filter((ss) => ss?.isActive)
                    .flatMap((ss) => {
                      const ssId = ss?._id;

                      const ssDirectProducts = (ss?.products || [])
                        .filter((product) => product?.isActive)
                        .map((product) => ({
                          ...product,
                          categoryId: catId,
                          subCategoryId: subId,
                          subSubCategoryId: ssId,
                        }));

                      // Products from sub-sub-sub-categories
                      const sssProducts = (ss?.subSubSubCategories || [])
                        .filter((sss) => sss?.isActive)
                        .flatMap((sss) => {
                          const sssId = sss?._id;

                          return (sss?.products || [])
                            .filter((product) => product?.isActive)
                            .map((product) => ({
                              ...product,
                              categoryId: catId,
                              subCategoryId: subId,
                              subSubCategoryId: ssId,
                              subSubSubCategoryId: sssId,
                            }));
                        });

                      return [...ssDirectProducts, ...sssProducts];
                    });

                  return [...directProducts, ...subSubProducts];
                }) || []
            );
          }) || [];

        setCategories(catData?.data || []);
        setProducts(allProducts.filter(isValidProduct));
        setTestimonials(testData?.data?.testimonials || []);
        setPromotional(testData?.data?.promotionalsVideo || []);
        setVendorProduct(venData?.data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const bannerSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false, // set true if images have very different aspect ratios
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="h-14 w-14 border-4 border-[#47b250] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (error) {
    return <p className="text-center text-red-600 mt-10">Error: {error}</p>;
  }

  return (
    <>
      {/* Banner */}
      <div className="w-full overflow-hidden">
        <Slider {...bannerSettings}>
          {banners.map((b, i) => (
            <div key={i}>
              <div className="border-[3px] border-[#35A93E] h-full">
                <img src={b.url} className="w-full h-full object-contain" />
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <div className="container-fluid mx-auto max-w-7xl my-5 py-5">
        <div>
          <Slider {...settings}>
            {companies.map((item, i) => (
              <div key={i}>
                <img
                  src={item.imgSrc}
                  alt={item.imgSrc}
                  width={100}
                  height={50}
                  // className='w-auto'
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>

      <div className="px-4">
        <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-5 mb-4">
          <div className="font-bold text-4xl tracking-tight">
            Popular Services
          </div>
          {/* <div>
            <button className="bg-transparent cursor-pointer hover:bg-primary text-primary font-medium hover:text-white py-3 px-4 border border-primary hover:border-transparent rounded-sm duration-300">
              Explore Classes
            </button>
          </div> */}
        </div>
        <div className="flex nowhitespace space-x-5 rounded-xl bg-white p-1 overflow-x-auto mb-4">
          {/* FOR DESKTOP VIEW */}
          <button
            onClick={() => setSelectedButton("dek")}
            className={`px-4 py-2 rounded-t-lg transition-all duration-300 hidden sm:block hover:cursor-pointer
    ${
      selectedButton === "dek"
        ? "bg-green-50 text-green-700 font-semibold border-b-4 border-green-600"
        : "text-gray-500 hover:text-green-600"
    }
  `}
          >
            Digital Emergency Health Kit
          </button>
          <button
            onClick={() => setSelectedButton("dmek")}
            className={`px-4 py-2 rounded-t-lg transition-all duration-300 hidden sm:block hover:cursor-pointer
    ${
      selectedButton === "dmek"
        ? "bg-green-50 text-green-700 font-semibold border-b-4 border-green-600"
        : "text-gray-500 hover:text-green-600"
    }
  `}
          >
            Digital and Medical Emergency Health Kit
          </button>

          <button
            onClick={() => setSelectedButton("diagnosis")}
            className={`px-4 py-2 rounded-t-lg transition-all duration-300 hidden sm:block hover:cursor-pointer
    ${
      selectedButton === "diagnosis"
        ? "bg-green-50 text-green-700 font-semibold border-b-4 border-green-600"
        : "text-gray-500 hover:text-green-600"
    }
  `}
          >
            Diagnosis Services
          </button>
          <button
            onClick={() => setSelectedButton("qhc")}
            className={`px-4 py-2 rounded-t-lg transition-all duration-300 hidden sm:block hover:cursor-pointer
    ${
      selectedButton === "qhc"
        ? "bg-green-50 text-green-700 font-semibold border-b-4 border-green-600"
        : "text-gray-500 hover:text-green-600"
    }
  `}
          >
            Quick Health Checkup
          </button>
          <button
            onClick={() => setSelectedButton("emt")}
            className={`px-4 py-2 rounded-t-lg transition-all duration-300 hidden sm:block hover:cursor-pointer
    ${
      selectedButton === "emt"
        ? "bg-green-50 text-green-700 font-semibold border-b-4 border-green-600"
        : "text-gray-500 hover:text-green-600"
    }
  `}
          >
            Express Medical Test
          </button>
          <button
            onClick={() => setSelectedButton("brs")}
            className={`px-4 py-2 rounded-t-lg transition-all duration-300 hidden sm:block hover:cursor-pointer
    ${
      selectedButton === "brs"
        ? "bg-green-50 text-green-700 font-semibold border-b-4 border-green-600"
        : "text-gray-500 hover:text-green-600"
    }
  `}
          >
            Body Recharge Station
          </button>

          {/* FOR MOBILE VIEW */}

          <FaGlobe
            onClick={() => setSelectedButton("dek")}
            className={
              "text-5xl sm:hidden block cursor-pointer " +
              (selectedButton === "dek"
                ? "text-black border-b-2 border-yellow-200"
                : "text-gray-400")
            }
          />

          <FaMobileAlt
            onClick={() => setSelectedButton("dmek")}
            className={
              "text-5xl sm:hidden block cursor-pointer " +
              (selectedButton === "dmek"
                ? "text-black border-b-2 border-yellow-200"
                : "text-gray-400")
            }
          />

          <FaDatabase
            onClick={() => setSelectedButton("diagnosis")}
            className={
              "text-5xl sm:hidden block cursor-pointer " +
              (selectedButton === "diagnosis"
                ? "text-black border-b-2 border-yellow-200"
                : "text-gray-400")
            }
          />

          <FaCloud
            onClick={() => setSelectedButton("qhc")}
            className={
              "text-5xl sm:hidden block cursor-pointer " +
              (selectedButton === "qhc"
                ? "text-black border-b-2 border-yellow-200"
                : "text-gray-400")
            }
          />

          <FaCloud
            onClick={() => setSelectedButton("emt")}
            className={
              "text-5xl sm:hidden block cursor-pointer " +
              (selectedButton === "emt"
                ? "text-black border-b-2 border-yellow-200"
                : "text-gray-400")
            }
          />

          <FaCloud
            onClick={() => setSelectedButton("brs")}
            className={
              "text-5xl sm:hidden block cursor-pointer " +
              (selectedButton === "brs"
                ? "text-black border-b-2 border-yellow-200"
                : "text-gray-400")
            }
          />
        </div>
        <div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-8">
            {!loading && nameElements.length > 0 ? (
              nameElements
            ) : (
              <p>No data to show</p>
            )}
          </div>
        </div>
      </div>

      {promotional.length > 0 && (
        <></>
        // <div className="py-10">
        //   <h2 className="text-4xl text-center underline text-[#47b250] font-semibold mb-10">
        //     Promotional Videos
        //   </h2>

        //   <div className="max-w-screen-2xl mx-auto py-6 px-4">
        //     <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
        //       {promotional.map((video, index) => (
        //         <div
        //           key={index}
        //           onClick={() => setSelectedVideo(video)}
        //           className="relative cursor-pointer border-2 border-[#35A93E] rounded-xl overflow-hidden shadow-md hover:shadow-lg transition"
        //         >
        //           {/* Thumbnail */}
        //           <img
        //             src={"/footerLogo.png"}
        //             alt="video thumbnail"
        //             className="w-full h-56 object-cover"
        //           />

        //           {/* Play icon overlay */}
        //           <div className="absolute inset-0 flex items-center justify-center bg-black/30">
        //             <div className="w-14 h-14 bg-white/90 rounded-full flex items-center justify-center">
        //               ▶
        //             </div>
        //           </div>
        //         </div>
        //       ))}
        //     </div>
        //   </div>
        // </div>
      )}

      {testimonials.length > 0 && (
        <></>
        // <div className="py-10">
        //   <h2 className="text-4xl text-center underline text-[#47b250] font-semibold mb-10">
        //     Testimonials Videos
        //   </h2>

        //   <div className="max-w-screen-2xl mx-auto py-6 px-4">
        //     <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
        //       {testimonials.map((video, index) => (
        //         <div
        //           key={index}
        //           onClick={() => setSelectedVideo(video)}
        //           className="relative cursor-pointer border-2 border-[#35A93E] rounded-xl overflow-hidden shadow-md hover:shadow-lg transition"
        //         >
        //           {/* Thumbnail */}
        //           <img
        //             src={"/footerLogo.png"}
        //             alt="video thumbnail"
        //             className="w-full h-56 object-cover"
        //           />

        //           {/* Play icon overlay */}
        //           <div className="absolute inset-0 flex items-center justify-center bg-black/30">
        //             <div className="w-14 h-14 bg-white/90 rounded-full flex items-center justify-center">
        //               ▶
        //             </div>
        //           </div>
        //         </div>
        //       ))}
        //     </div>
        //   </div>
        // </div>
      )}

      {/* Modal */}
      {selectedVideo && (
        <div
          className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center px-4"
          onClick={() => setSelectedVideo(null)} // click on overlay closes modal
        >
          <div
            className="relative w-full max-w-3xl bg-black rounded-xl overflow-hidden"
            onClick={(e) => e.stopPropagation()} // prevent click inside video container from closing
          >
            <button
              onClick={() => setSelectedVideo(null)}
              className="absolute top-3 right-3 z-10 w-10 h-10 flex items-center justify-center bg-black/50 text-white text-2xl rounded-full hover:bg-black/70 transition"
            >
              ✕
            </button>

            <video
              src={selectedVideo}
              controls
              autoPlay
              className="w-full max-h-[80vh] object-contain"
            />
          </div>
        </div>
      )}

      {/* Categories */}
      {/* <div className="max-w-screen-2xl mx-auto py-10 px-4">
        <h2 className="text-4xl text-center underline text-[#47b250] font-semibold mb-8">
          Categories
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
          {categories.map((cat) => {
            const enabled = hasProducts(cat);

            return (
              <div
                key={cat._id}
                onClick={
                  enabled
                    ? () =>
                        navigate(`/category/${cat._id}`, {
                          state: { category: cat },
                        })
                    : undefined
                }
                className={`relative border rounded-lg p-4 text-center ${
                  enabled ? "cursor-pointer hover:shadow-md" : "opacity-60"
                }`}
              >
                <img
                  src={cat?.images?.[0]}
                  className="h-[100px] w-full object-contain mb-2"
                />
                <p className="text-sm font-medium">{cat.categoryName}</p>

                {!enabled && (
                  <div className="absolute inset-0 bg-black/50 flex items-center justify-center rounded-lg">
                    <span className="text-white font-semibold text-sm">
                      Coming Soon
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div> */}

      {/* Products */}
      <div className="max-w-screen-2xl mx-auto py-12 px-4">
        <h2 className="text-4xl font-semibold mb-8">Products</h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-6">
          {products.map((product) => {
            return (
              <div
                key={product._id}
                onClick={() =>
                  navigate(`/product-details/${product._id}`, {
                    state: {
                      product,
                      category: product.categoryId,
                      subCategory: product.subCategoryId || null,
                      subSubCategory: product.subSubCategoryId || null,
                      subSubSubCategory: product.subSubSubCategoryId || null,
                    },
                  })
                }
                className="border rounded-lg p-4 cursor-pointer hover:shadow-lg"
              >
                <img
                  src={
                    product?.variations?.[0]?.images?.[0] ||
                    product?.images?.[0]
                  }
                  className="h-[160px] w-full object-contain mb-3"
                />
                <h3 className="text-sm font-medium">{product.productName}</h3>
                <p className="text-sm text-gray-600">
                  {getCurrencySymbol()}
                  {convertPrice(
                    product?.price?.amount ||
                      product?.variations?.[0]?.price?.amount,
                  )}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      {/* Vendor Products */}
      {/* <div className="max-w-screen-2xl mx-auto py-12 px-4">
        <h2 className="text-4xl text-center underline text-[#47b250] font-semibold mb-8">
          Health Care Products
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-6">
          {vendorProduct.map((product) => {
            return (
              <div
                key={product._id}
                onClick={() =>
                  navigate(`/vendor-product-details/${product._id}`)
                }
                className="border rounded-lg p-4 cursor-pointer hover:shadow-lg"
              >
                <img
                  src={product?.images?.[0]}
                  className="h-[160px] w-full object-contain mb-3"
                />
                <h3 className="text-sm font-medium">{product.productName}</h3>
                <p className="text-sm text-gray-600">
                  {getCurrencySymbol()}
                  {convertPrice(product?.variations?.[0]?.price?.amount)}
                </p>
              </div>
            );
          })}
        </div>
      </div> */}
    </>
  );
};

export default Home;
